import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["text", "sx", "to"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Box } from '@mui/material';
import { Translation } from 'react-i18next';
import { RouterLink } from '../router-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BackButton = function BackButton(_ref) {
  var text = _ref.text,
      sx = _ref.sx,
      to = _ref.to,
      linkProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Box, {
    sx: mergeSxProps(sx, {
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center'
    }),
    "data-element": "Box",
    "data-component": "BackButton",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsxs(RouterLink, _objectSpread(_objectSpread({
      to: to
    }, linkProps), {}, {
      "data-element": "RouterLink",
      "data-component": "BackButton",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(ArrowBack, {
        sx: {
          mr: 1,
          height: 20,
          width: 20,
          verticalAlign: 'middle'
        },
        "data-element": "ArrowBack",
        "data-component": "BackButton",
        "data-source-file": "index.tsx"
      }), text && /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return t(text);
        }
      })]
    }))
  });
};